import { ParamMap } from '@angular/router';
import { Duration, SearchEngineFieldDuration } from '@domains/search-engine/entities/duration-field';
import {
  FieldExtraConfigWithValue,
  FieldInputConfig,
  FieldStyleConfig,
  SearchEngineField,
  SearchEngineFieldType,
} from '@domains/search-engine/search-engine-field';

export interface SearchEngineFieldSelectDurationValue {
  label: string;
  paramValue: string;
  showInputFields: boolean;
}

export interface DurationValue extends Duration {
  [key: string]: unknown;
}

export class SearchEngineFieldSelectDuration
  extends SearchEngineFieldDuration<DurationValue>
  implements SearchEngineField<DurationValue>
{
  value: SearchEngineFieldSelectDurationValue[];

  constructor(
    inputConfig: FieldInputConfig,
    extraConfig: FieldExtraConfigWithValue<SearchEngineFieldSelectDurationValue[]>,
    inputStyle?: FieldStyleConfig
  ) {
    super(SearchEngineFieldType.DurationSelect, inputConfig, inputStyle);
    this.value = extraConfig.value;
  }

  valueToQueryParams(value: DurationValue): { [key: string]: string } {
    if (value) {
      return {
        [this.name]: value[this.name],
        ...super.getQueryParams(value?.from, value?.to),
      };
    }

    return {};
  }

  paramMapToValue(paramMap: ParamMap): DurationValue | null {
    const duration = super.getDuration(paramMap);
    const value = paramMap.get(this.name);
    if (value) {
      return {
        [this.name]: value,
        from: duration.from,
        to: duration.to,
      };
    }
    return null;
  }
}
